import React, { useState, useEffect } from 'react'
import { Breadcrumb, Table, Form, Col, InputGroup, FormControl, Row } from 'react-bootstrap'
import Notification from '../Notification'
import { LinkContainer } from 'react-router-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCarBattery, faGasPump } from '@fortawesome/free-solid-svg-icons'

const ElecGasCar = () => {
    const [gasPrice, setGasPrice] = useState('2.69')
    const [energyPrice, setEnergyPrice] = useState('13.95')
    const [energyConsumption, setEnergyConsumption] = useState('20')
    const [gasConsumption, setGasConsumption] = useState('6')
    const [distance, setDistance] = useState('100')
    const [electricCarMonthlyCosts, setElectricCarMonthlyCosts] = useState('')
    const [gasCarMonthlyCosts, setGasCarMonthlyCosts] = useState('')
    const [electricCarPriceReduce, setElectricCarPriceReduce] = useState('')
    const [gasCarPriceReduce, setGasCarPriceReduce] = useState('')
    const [message, setMessage] = useState('')

    useEffect(() => {
        document.title = 'Sähköauto-polttomoottoriauto hintavertailu - Laske & Muunna'
        countResult()
    })

    const formatInput = (value) => {
        value = value.replace(/[^\d.,]/g, '')
        value = value.replace(/,/g, '.')
        value = value.replace(/^(\d*\.?)|(\d*)\.?/g, "$1$2")
        return value
    }

    const handleEnergyPriceChange = (value) => {
        value = formatInput(value)
        setEnergyPrice(value)
        countResult()
    }

    const handleGasPriceChange = (value) => {
        value = formatInput(value)
        setGasPrice(value)
        countResult()
    }

    const handleEnergyConsumptionChange = (value) => {
        value = formatInput(value)
        setEnergyConsumption(value)
        countResult()
    }

    const handleGasConsumptionChange = (value) => {
        value = formatInput(value)
        setGasConsumption(value)
        countResult()
    }

    const handleElectricCarMonthlyCostsChange = (value) => {
        value = formatInput(value)
        setElectricCarMonthlyCosts(value)
        countResult()
    }

    const handleGasCarMonthlyCostsChange = (value) => {
        value = formatInput(value)
        setGasCarMonthlyCosts(value)
        countResult()
    }

    const handleElectricCarPriceReduceChange = (value) => {
        value = formatInput(value)
        setElectricCarPriceReduce(value)
        countResult()
    }

    const handleGasCarPriceReduceChange = (value) => {
        value = formatInput(value)
        setGasCarPriceReduce(value)
        countResult()
    }

    const handleDistanceChange = (value) => {
        value = formatInput(value)
        setDistance(value)
        countResult()
    }

    const formatValue = (value) => {
        if (value.length === 0) {
            value = 0
        }
        value = parseFloat(value)
        return value
    }

    const countResult = () => {
        const electricCarTotalCosts = formatValue(electricCarMonthlyCosts) + formatValue(electricCarPriceReduce) + ((formatValue(energyPrice) / 100) * formatValue(energyConsumption) * (formatValue(distance) / 100))
        const gasCarTotalCosts = formatValue(gasCarMonthlyCosts) + formatValue(gasCarPriceReduce) + (formatValue(gasPrice) * formatValue(gasConsumption) * (formatValue(distance) / 100))
        const diff = electricCarTotalCosts - gasCarTotalCosts

        if (diff < 0) {
            setMessage(`Sähköauton kuukausikustannukset ovat ${-diff.toFixed(2)} € pienemmät kuin polttomoottoriauton ja vuosikustannukset ovat ${(-diff * 12).toFixed(2)}  € pienemmät kuin polttomoottoriauton.`)
        } else if (diff > 0) {
            setMessage(`Polttomoottoriauton kuukausikustannukset ovat ${diff.toFixed(2)} € pienemmät kuin sähköauton ja vuosikustannukset ovat ${(diff * 12).toFixed(2)}  € pienemmät kuin sähköauton.`)
        } else {
            setMessage(`Kuukausikustannukset syöttämilläsi luvuilla ovat samat: ${electricCarTotalCosts.toFixed(2)} €`)
        }
    }

    return (
        <div>
            <Breadcrumb>
                <LinkContainer to="../">
                    <Breadcrumb.Item>
                        Alkuun
                    </Breadcrumb.Item>
                </LinkContainer>
                <LinkContainer to="./">
                    <Breadcrumb.Item>
                        Hyöty
                    </Breadcrumb.Item>
                </LinkContainer>
                <Breadcrumb.Item active>
                    Sähköauto-polttomoottoriauto hintavertailu
                </Breadcrumb.Item>
            </Breadcrumb>
            <div>
                <div style={{ maxWidth: '90%' }}>
                    <h2>
                        Sähköauto-polttomoottoriauto hintavertailu
                    </h2>
                </div>
                <div className='calculator'>
                    <p>
                        Tällä laskurilla voit vertailla sähköauton kustannuksia polttomoottoriauton kustannuksiin.
                        Voit vertailla pelkkää polttoaineen hintaa sähkön hintaan tietyllä ajetulla kilometrimäärällä
                        tai syöttää laskuriin myös auton kuukausittaiset kustannukset, kuten lainan lyhennykset ja vakuutukset ja vertailla kokonaiskustannuksia.
                        Voit myös arvioida auton arvon aleneman ja syöttää laskuriin kuukausittaisen arvon aleneman, jolloin laskuri huomioi myös arvon aleneman.
                        Laskuriin oletuksena syötetyt sähkön kulutus, polttoaineen hinta ja polttoaineen kulutus ovat arvioita ja voivat vaihdella paljonkin automallien välillä.
                        Myös sähkön hinta voi vaihdella paljonkin ja ajantasainen hinta kannattaa tarkistaa omalta sähkölaskulta tai pörssisähkön tapauksessa verkosta.
                    </p>
                    <div>
                        <Form>
                            <Row>
                                <Col md="6" className="block-example border-right border-dark">
                                    <h5>Sähköauto <FontAwesomeIcon icon={faCarBattery} className="iconsStyle"/></h5>
                                    <Form.Label>Sähkön hinta:</Form.Label>
                                    <InputGroup className="mb-2">
                                        <FormControl
                                            onChange={({ target }) => handleEnergyPriceChange(target.value)}
                                            value={energyPrice}
                                            placeholder="Sähkön hinta senttiä / kWh"
                                        />
                                        <InputGroup.Text>c/kWh</InputGroup.Text>
                                    </InputGroup>
                                    <Form.Label>Sähkön kulutus:</Form.Label>
                                    <InputGroup className="mb-2">
                                        <FormControl
                                            onChange={({ target }) => handleEnergyConsumptionChange(target.value)}
                                            value={energyConsumption}
                                            placeholder="Sähkön kulutus / 100km"
                                        />
                                        <InputGroup.Text>kWh/100km</InputGroup.Text>
                                    </InputGroup>
                                    <Form.Label>Kuukausikulut:</Form.Label>
                                    <InputGroup className="mb-2">
                                        <FormControl
                                            onChange={({ target }) => handleElectricCarMonthlyCostsChange(target.value)}
                                            value={electricCarMonthlyCosts}
                                            placeholder="Laina lyhennys, vakuutukset..."
                                        />
                                        <InputGroup.Text>€/kk</InputGroup.Text>
                                    </InputGroup>
                                    <Form.Label>Arvon alenema:</Form.Label>
                                    <InputGroup className="mb-2">
                                        <FormControl
                                            onChange={({ target }) => handleElectricCarPriceReduceChange(target.value)}
                                            value={electricCarPriceReduce}
                                            placeholder="Arvon alenema kuukaudessa"
                                        />
                                        <InputGroup.Text>€/kk</InputGroup.Text>
                                    </InputGroup>
                                </Col>
                                <Col md="6">
                                    <h5>Polttomoottoriauto <FontAwesomeIcon icon={faGasPump} className="iconsStyle"/></h5>
                                    <Form.Label>Polttoaineen hinta:</Form.Label>
                                    <InputGroup className="mb-2">
                                        <FormControl
                                            onChange={({ target }) => handleGasPriceChange(target.value)}
                                            value={gasPrice}
                                            placeholder="Polttoaineen hinta € / litra"
                                        />
                                        <InputGroup.Text>€/l</InputGroup.Text>
                                    </InputGroup>
                                    <Form.Label>Polttoaineen kulutus:</Form.Label>
                                    <InputGroup className="mb-2">
                                        <FormControl
                                            onChange={({ target }) => handleGasConsumptionChange(target.value)}
                                            value={gasConsumption}
                                            placeholder="Polttoaineen kulutus / 100km"
                                        />
                                        <InputGroup.Text>l/100km</InputGroup.Text>
                                    </InputGroup>
                                    <Form.Label>Kuukausikulut:</Form.Label>
                                    <InputGroup className="mb-2">
                                        <FormControl
                                            onChange={({ target }) => handleGasCarMonthlyCostsChange(target.value)}
                                            value={gasCarMonthlyCosts}
                                            placeholder="Laina lyhennys, vakuutukset..."
                                        />
                                        <InputGroup.Text>€/kk</InputGroup.Text>
                                    </InputGroup>
                                    <Form.Label>Arvon alenema:</Form.Label>
                                    <InputGroup className="mb-2">
                                        <FormControl
                                            onChange={({ target }) => handleGasCarPriceReduceChange(target.value)}
                                            value={gasCarPriceReduce}
                                            placeholder="Arvon alenema kuukaudessa"
                                        />
                                        <InputGroup.Text>€/kk</InputGroup.Text>
                                    </InputGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Label>Ajomäärä</Form.Label>
                                    <InputGroup className="mb-2">
                                        <FormControl
                                            onChange={({ target }) => handleDistanceChange(target.value)}
                                            value={distance}
                                            placeholder="Kilometriä kuukaudessa"
                                        />
                                        <InputGroup.Text>km/kk</InputGroup.Text>
                                    </InputGroup>
                                </Col>
                            </Row>
                        </Form>
                        <Notification message={message} errorMessage="" />
                    </div>
                </div>
                <Table responsive='sm' size='sm' className='table table-bordered table-hover hoverCells' style={{ marginBottom: '50px' }}>
                    <tbody>
                        <tr key={0}>
                            <th scope="row">Kuukausikustannukset</th>
                            <th scope="row">Sähköauto</th>
                            <th scope="row">Polttomoottoriauto</th>
                        </tr>
                        <tr key={1}>
                            <td>
                                <b>Kiinteät kustannukset</b>
                            </td>
                            <td>
                                {formatValue(electricCarMonthlyCosts).toFixed(2)}
                            </td>
                            <td>
                                {formatValue(gasCarMonthlyCosts).toFixed(2)}
                            </td>
                        </tr>
                        <tr key={2}>
                            <td>
                                <b>Käyttökustannukset</b>
                            </td>
                            <td>
                                {((formatValue(energyPrice) / 100) * formatValue(energyConsumption) * (formatValue(distance) / 100)).toFixed(2)}
                            </td>
                            <td>
                                {(formatValue(gasPrice) * formatValue(gasConsumption) * (formatValue(distance) / 100)).toFixed(2)}
                            </td>
                        </tr>
                        <tr key={3}>
                            <td>
                                <b>Arvon alenema</b>
                            </td>
                            <td>
                                {formatValue(electricCarPriceReduce).toFixed(2)}
                            </td>
                            <td>
                                {formatValue(gasCarPriceReduce).toFixed(2)}
                            </td>
                        </tr>
                        <tr key={4} style={{'borderTop': '2px solid black'}}>
                            <td>
                                <b>Yhteensä</b>
                            </td>
                            <td>
                                {(formatValue(electricCarMonthlyCosts) + formatValue(electricCarPriceReduce) + (formatValue(energyPrice) / 100) * formatValue(energyConsumption) * (formatValue(distance) / 100)).toFixed(2)}
                            </td>
                            <td>
                                {(formatValue(gasCarMonthlyCosts) + formatValue(gasCarPriceReduce) + formatValue(gasPrice) * formatValue(gasConsumption) * (formatValue(distance) / 100)).toFixed(2)}
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </div>
            <hr />
        </div>
    )
}

export default ElecGasCar